var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "card-wrapper white-label d-flex flex-column position-relative h-100",
    },
    [
      _c("h2", { staticClass: "plan-title font-outfit-semi-bold" }, [
        _vm._v(" " + _vm._s(_vm.$t("pages.pricing.whiteLabel.title")) + " "),
      ]),
      _c("p", { staticClass: "plan-description mt-0" }, [
        _vm._v(
          " " + _vm._s(_vm.$t("pages.pricing.whiteLabel.description")) + " "
        ),
      ]),
      _c(
        "div",
        {
          staticClass: "quote-slot d-flex flex-column justify-content-center",
          class: { "with-save": _vm.hasSaveText },
        },
        [
          _c("p", { staticClass: "quote-text font-outfit-bold m-0" }, [
            _vm._v(
              " " + _vm._s(_vm.$t("pages.pricing.whiteLabel.getAQuote")) + " "
            ),
          ]),
        ]
      ),
      _c(
        "div",
        { staticClass: "actions" },
        [
          _c("div", { staticClass: "input-number-spacer" }),
          _c(
            "ib-button",
            {
              staticClass: "cta-button w-100",
              attrs: { variant: "blue", size: "sm" },
              on: {
                click: function ($event) {
                  return _vm.$emit("contact")
                },
              },
            },
            [
              _vm._v(
                " " + _vm._s(_vm.$t("pages.pricing.whiteLabel.contactUs")) + " "
              ),
            ]
          ),
        ],
        1
      ),
      _c("div", { staticClass: "features text-left" }, [
        _c("h5", { staticClass: "title font-outfit-medium" }, [
          _vm._v(
            " " + _vm._s(_vm.$t("pages.pricing.whiteLabel.featuresTitle")) + " "
          ),
        ]),
        _c(
          "ul",
          _vm._l(_vm.features, function (feature) {
            return _c(
              "li",
              { key: feature.id, staticClass: "active font-outfit-light" },
              [
                _c(
                  "ib-tooltip",
                  { attrs: { content: feature.hint, dark: true } },
                  [_c("span", [_vm._v(_vm._s(feature.text))])]
                ),
              ],
              1
            )
          }),
          0
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }